/**
 * Legacy PosCloudConfigurationService module — preserved as an empty
 * AngularJS module so existing dependencies
 * (`acme.common.service.posCloudConfiguration`) keep resolving.
 *
 * The actual `PosCloudConfigurationService` is now an Angular 18 class
 * registered as a downgraded factory under the same name in
 *   apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 *
 * Implementation:
 *   apps/b2b-frontend/app/core/api/pos-cloud-configuration/pos-cloud-configuration.service.ts
 *
 * Do NOT register `.provider('PosCloudConfigurationService', ...)` here —
 * it would shadow the downgraded service.
 */
angular.module('acme.common.service.posCloudConfiguration', []);
